import React, { FC } from 'react';
import { View } from 'react-native';
import { HourlyWeatherWidget } from '@components';

import { styles } from './styles';

type HourlyWeatherMiddleRowProps = {
  nextFocusDown: unknown;
  nextFocusUp: unknown;
  defaultFocus: unknown;
};

export const HourlyWeatherMiddleRow: FC<HourlyWeatherMiddleRowProps> = ({
  nextFocusDown,
  nextFocusUp,
  defaultFocus,
}) => (
  <View style={styles.middleRowWrapper}>
    <View style={styles.rowWrapper}>
      <HourlyWeatherWidget defaultFocus={defaultFocus} nextFocusDown={nextFocusDown} nextFocusUp={nextFocusUp} />
    </View>
  </View>
);
